import "core-js/modules/es.json.stringify.js";
//
//
//
//
//
//
export default {
  name: 'App',
  created: function created() {
    var _this = this;

    // 以下代码是处理，页面刷新vuex里面store数据丢失的问题
    // 在页面加载时读取sessionStorage里的状态信息
    if (sessionStorage.getItem("store")) {
      this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(sessionStorage.getItem("store"))));
    } // 在页面刷新时将vuex里的信息保存到sessionStorage里


    window.addEventListener("beforeunload", function () {
      sessionStorage.setItem("store", JSON.stringify(_this.$store.state));
    });
  }
};